import { render, staticRenderFns } from "./AgConfirmDialog.vue?vue&type=template&id=27ddb5f8&scoped=true"
import script from "./AgConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AgConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AgConfirmDialog.vue?vue&type=style&index=0&id=27ddb5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ddb5f8",
  null
  
)

export default component.exports